import { render, staticRenderFns } from "./GroupsByInvoice.vue?vue&type=template&id=3b92b1f8&scoped=true"
import script from "./GroupsByInvoice.vue?vue&type=script&lang=js"
export * from "./GroupsByInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b92b1f8",
  null
  
)

export default component.exports